import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, Transition as _Transition, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icons/calendar.png'


const _withScopeId = n => (_pushScopeId("data-v-312421c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container content-start" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Bu potansiyel \"İnaktif\" olarak işaretlenmiş. Teknik olarak, bu iş üzerinde değişiklik ve güncellemeler yapabilirsiniz. Ancak uygulama çapında daha verimli kullanılabilmesi için, güncelleme durumunda potansiyeli önce tekrar aktif hale getirmenizi öneririz.", -1))
const _hoisted_3 = {
  key: 1,
  class: "two-column-container sidebar-right col-start-1 col-end-13 mt-8"
}
const _hoisted_4 = { class: "flex items-center gap-4 relative" }
const _hoisted_5 = { class: "w-full py-4 bg-[var(--box-color)] rounded-xl" }
const _hoisted_6 = {
  key: 0,
  class: "assignee-container"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitle !mt-[4.8rem] mb-6" }, "Potansiyel Açıklaması", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitle !mt-[4.8rem] mb-6" }, "İletişim Bilgileri", -1))
const _hoisted_9 = { class: "contact-section" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitle !mt-[4.8rem] mb-6" }, "Güncellemeler", -1))
const _hoisted_11 = { class: "updates-container" }
const _hoisted_12 = {
  key: 0,
  class: "comments-container"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-2xl italic text-gray-400 mb-6" }, "Bu potansiyel için herhangi bir güncelleme eklenmemiş. Potansiyeli daha verimli takip etmek için belli aralıklarla güncellemeler paylaşabilirsiniz.", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: ""
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitle mb-6" }, "İşlemler", -1))
const _hoisted_18 = { class: "potential-buttons" }
const _hoisted_19 = { class: "potential-information mt-[3.6rem] border border-gray-300 rounded-xl p-4 flex flex-col gap-6" }
const _hoisted_20 = { class: "flex items-center justify-between" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-0" }, "Potansiyel Derecesi", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_23 = { class: "flex items-center gap-2 text-2xl" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Potansiyel Tipi:", -1))
const _hoisted_25 = { class: "mb-0" }
const _hoisted_26 = {
  key: 0,
  class: "flex items-center gap-2 text-2xl"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Keşfeden:", -1))
const _hoisted_28 = { class: "mb-0" }
const _hoisted_29 = {
  key: 1,
  class: "flex items-center gap-2 text-2xl"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Öneren: ", -1))
const _hoisted_31 = { class: "mb-0" }
const _hoisted_32 = { class: "potential-meta mt-[3.6rem] border border-gray-300 rounded-xl p-4 flex flex-col gap-6" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Ekleme Bilgileri", -1))
const _hoisted_34 = { class: "flex items-center gap-2 text-2xl" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "mb-0" }
const _hoisted_37 = { class: "flex items-center gap-3 text-2xl" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-8 filter-main",
  src: _imports_0,
  alt: "Calendar Icon"
}, null, -1))
const _hoisted_39 = { class: "mb-0" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-8" }, null, -1))
const _hoisted_41 = { class: "latest-update-container" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-4" }, "Son Güncelleme", -1))
const _hoisted_43 = { class: "flex items-center gap-2 text-2xl" }
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "mb-0" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " - ", -1))
const _hoisted_47 = { class: "mb-0" }

import type { ColorMetaField } from '@/types/metas'
import type { AcContactData, AcPotential } from '@/types/crm'
import type { AcReminder } from '@/types/application'
import type { fetchedUser } from '@/types/fetchedUser'

import {ref, computed, onBeforeMount, onBeforeUnmount} from 'vue'
import { useFetchRealTimePotential, postCRMReminder, movePotentialToTracked } from '@/composables/crmBasedFunctions'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useGetDocs } from '@/mixins/modularFirebaseOperations'
import { formatUser, modalClosed, formatDate } from '@/mixins/visualFormatters'
import { updateSingleField, addSingleArrayItem, deleteFirebaseArrayData } from '@/mixins/modularFirebaseOperations'
import { trackLastUpdate } from '@/composables/loggers'
import resetBackground from "@/mixins/resetBackground";
import removeBackground from "@/mixins/removeBackground";

// Import available reusable components
import ModernStatusChip from '@/components/reusable/modernStatusChip.vue'
import StarPicker from '@/components/reusable/starPicker.vue'
import CommentListDisplayer from '@/components/reusable/commentListDisplayer.vue'
import AcMediumModal from '@/components/reusable/teleports/acMediumModal.vue'
import StatusBar from '@/components/reusable/statusBar.vue'
import ContactDisplayer from '@/components/reusable/contactDisplayer.vue'
import AddReminderForm from '@/components/crm-components/addReminderForm.vue'
import CommentField from '@/components/reusable/commentField.vue'
import EditableTitle from '@/components/reusable/editableTitle.vue'
import EditableTextarea from '@/components/reusable/editableTextarea.vue'
import UserDisplay from '@/components/reusable/userDisplay.vue'
import StatusChanger from '@/components/reusable/statusChanger.vue'




export default /*#__PURE__*/_defineComponent({
  __name: 'potentialDetail',
  setup(__props) {


const potentialId = useRoute().params.id
const router = useRouter()
const { potential, isLoadingPotential } = useFetchRealTimePotential(potentialId as string)
//Eslint ignore no-unused-vars
//eslint-disable-next-line
const { docs, isLoadingDocs } = useGetDocs(`crm/jobCategories/list`)

const isPickingNewCategory = ref(false)
const isAddingReminder = ref(false)
const store = useStore()
const userProfile = computed(() => store.getters['user/userProfile'])
const formattedUser = computed(() => formatUser(userProfile.value))

const updateSinglePotentialField = async (field: string, value: string) => {
    await updateSingleField(
        `crm/potentials/list/${potentialId}`,
        field,
        value,
    )
    await trackLastUpdate(
        `crm/potentials/list/${potentialId}`,
        {
            date: new Date(),
            user: formattedUser.value
        }
    )
}

const updatePotentialCategories = async (category: ColorMetaField) => {
    await addSingleArrayItem(
        `crm/potentials/list/${potentialId}`,
        "potentialCategories",
        category
    )
    await trackLastUpdate(
        `crm/potentials/list/${potentialId}`,
        {
            date: new Date(),
            user: formattedUser.value
        }
    )
}

const addUserToPotential = async (user: fetchedUser) => {
    await addSingleArrayItem(
        `crm/potentials/list/${potentialId}`,
        "assignedTo",
        user
    )
    await trackLastUpdate(
        `crm/potentials/list/${potentialId}`,
        {
            date: new Date(),
            user: formattedUser.value
        }
    )
}

const addCommentToPotential = async (comment: string) => {

    const commentObj = {
        comment: comment,
        date: new Date(),
        user: formattedUser.value
    }

    await addSingleArrayItem(
        `crm/potentials/list/${potentialId}`,
        "comments",
        commentObj
    )
    await trackLastUpdate(
        `crm/potentials/list/${potentialId}`,
        {
            date: new Date(),
            user: formattedUser.value
        }
    )
}

const removeUserFromPotential = async (user: fetchedUser) => {
    await deleteFirebaseArrayData(
        `crm/potentials/list/${potentialId}`,
        potentialId as string,
        "assignedTo",
        user
    )
    await trackLastUpdate(
        `crm/potentials/list/${potentialId}`,
        {
            date: new Date(),
            user: formattedUser.value
        }
    )
}

const handleContactAdded = async (contact: AcContactData) => {
    const currentContacts = potential.value?.contact || []
    const updatedContacts = [...currentContacts, contact]
    
    await updateSingleField(
        `crm/potentials/list/${potentialId}`,
        "contact",
        updatedContacts,
    )
    
    await trackLastUpdate(
        `crm/potentials/list/${potentialId}`,
        {
            date: new Date(),
            user: formattedUser.value
        }
    )
}

const handleContactDeleted = async (contact: AcContactData) => {
    if (!potential.value?.contact) return
    
    // Filter out the deleted contact
    const updatedContacts = potential.value.contact.filter(existingContact => {
        return !(existingContact.title === contact.title && 
                existingContact.emailAddress === contact.emailAddress &&
                existingContact.phoneNumber === contact.phoneNumber)
    })
    
    await updateSingleField(
        "contact",
        updatedContacts,
        `crm/potentials/list/${potentialId}`
    )
    
    await trackLastUpdate(
        `crm/potentials/list/${potentialId}`,
        {
            date: new Date(),
            user: formattedUser.value
        }
    )
}

const handleContactUpdated = async (updatedContact: AcContactData, originalContact: AcContactData) => {
    if (!potential.value?.contact) return
    
    // Find and replace the original contact with the updated one
    const updatedContacts = potential.value.contact.map(contact => {
        // Compare contacts by their properties to find the match
        if (contact.title === originalContact.title && 
            contact.emailAddress === originalContact.emailAddress &&
            contact.phoneNumber === originalContact.phoneNumber) {
            return updatedContact
        }
        return contact
    })
    
    // Update the entire contact array
    await updateSingleField(
        `crm/potentials/list/${potentialId}`,
        "contact",
        updatedContacts,
    )
    
    await trackLastUpdate(
        `crm/potentials/list/${potentialId}`,
        {
            date: new Date(),
            user: formattedUser.value
        }
    )
}

// Potential actions

const moveToTracked = async () => {
    const confirmation = confirm("Bu öge potansiyeller listesinden kaldırılarak takip listesine eklenecektir. İşlem tamamlandığında otomatik olarak Takip ekranına yönlendirileceksiniz.")
    if(confirmation){
    try {
        await movePotentialToTracked(potential.value as AcPotential, userProfile.value)
        router.push(`/crm/tracked/list`)
        } catch (error) {
            console.error(error)
        }
    }
}

const addReminder = () => {

    console.log(potential.value?.assignedTo)
    
    if(potential.value?.assignedTo.length === 0){
        alert("Bu potansiyel için hiçbir sorumlu eklenmediği için hatırlatma ekleyemezsiniz. Lütfen önce sorumlu ekleyiniz.")
        return
    } 

    isAddingReminder.value = true

}

const handleReminderAdded = async (reminder: Partial<AcReminder>) => {
    

    if(potential.value?.assignedTo.length === 0){
        alert("Bu potansiyel için hiçbir sorumlu eklenmediği için hatırlatma ekleyemezsiniz. Lütfen önce sorumlu ekleyiniz.")
        return
    }

    try{
        await postCRMReminder(
            reminder.additionalMessage,
            reminder.date,
            potential.value as AcPotential,
            "potential-detail"
        )
    } catch (error) {
        alert(`Hatırlatma eklenirken bir hata oluştu: ${error}. Lütfen bu hatayı yazılım ekibiniz ile paylaşın.`)
    } finally {
        isAddingReminder.value = false
        modalClosed()
    }
}

const handlePotentialCategoryDeleted = async (categoryId: string) => {
    const category = potential.value?.potentialCategories.find((category: ColorMetaField) => category.id === categoryId)

    if(category){
        try {
            await deleteFirebaseArrayData(
                "crm/potentials/list/",
                potentialId as string,
                "potentialCategories",
                category
            )
            await trackLastUpdate(
                `crm/potentials/list/${potentialId}`,
                {
                    date: new Date(),
                    user: formattedUser.value
                }
            )

            
        } catch (error) {
            console.error(error)
        }
    }
}

const sendIntroMail = () => {
    alert("Tanıtım belgesi gönderme özelliği şu anda yapım aşamasındadır. Lütfen daha sonra tekrar deneyiniz.")
}

onBeforeMount(() => {
    removeBackground.methods.removeBackground()
})

onBeforeUnmount(() => {
    resetBackground.methods.resetBackground()
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(potential)?.status === 'INACTIVE')
      ? (_openBlock(), _createBlock(StatusBar, {
          key: 0,
          backgroundColor: '#021640',
          class: "col-start-1 col-end-13 !w-full !mb-0 !mt-8"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_unref(isLoadingPotential))
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _createElementVNode("main", null, [
            _createElementVNode("header", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(potential)?.potentialCategories, (category) => {
                return (_openBlock(), _createBlock(ModernStatusChip, {
                  onDeleteClicked: _cache[0] || (_cache[0] = ($event: any) => (handlePotentialCategoryDeleted($event))),
                  "is-deletable": true,
                  key: category.id,
                  "bg-colors": { [category.id]: category.color },
                  value: category.id,
                  text: category.name
                }, null, 8, ["bg-colors", "value", "text"]))
              }), 128)),
              _createElementVNode("button", {
                class: "ac-square-button bg-black hover-bg-[#021640] text-white rounded-lg text-xl",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (isPickingNewCategory.value = true))
              }, "+"),
              (isPickingNewCategory.value)
                ? (_openBlock(), _createBlock(StatusChanger, {
                    key: 0,
                    "changer-title": "Kategori Seç",
                    "status-list": _unref(docs),
                    "bg-colors": _unref(docs).map((category) => category.color),
                    "is-changeable": true,
                    "ac-position": "[400, 40]",
                    onCancelled: _cache[2] || (_cache[2] = ($event: any) => (isPickingNewCategory.value = false)),
                    onUpdated: _cache[3] || (_cache[3] = ($event: any) => (updatePotentialCategories($event)))
                  }, null, 8, ["status-list", "bg-colors"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(EditableTitle, {
              class: "mt-1 !mb-8",
              onTitleEdited: _cache[4] || (_cache[4] = ($event: any) => (updateSinglePotentialField('title', $event))),
              text: _unref(potential)?.title
            }, null, 8, ["text"]),
            _createElementVNode("div", _hoisted_5, [
              (_unref(potential)?.assignedTo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(UserDisplay, {
                      onUserAdded: _cache[5] || (_cache[5] = ($event: any) => (addUserToPotential($event))),
                      onUserRemoved: _cache[6] || (_cache[6] = ($event: any) => (removeUserFromPotential($event))),
                      class: "px-4",
                      "show-add-button": true,
                      "add-button-text": "Sorumlu Ekle",
                      "empty-state-text": "Bu potansiyel için hiçbir sorumlu eklenmemiş. Sorumlular ekleyerek bu potansiyeli daha iyi takip edebiliriz.",
                      "empty-state-icon": "~/assets/icons/no-user.png",
                      "allow-remove": true,
                      "allow-add": true,
                      "show-user-names": false,
                      "image-size": 'smaller',
                      users: _unref(potential)?.assignedTo
                    }, null, 8, ["users"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_7,
            _createVNode(EditableTextarea, {
              class: "!mt-[2.4rem]",
              onEditCancelled: () => { },
              onEditCompleted: _cache[7] || (_cache[7] = ($event: any) => (updateSinglePotentialField('description', $event))),
              text: _unref(potential)?.description
            }, null, 8, ["text"]),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(ContactDisplayer, {
                cols: 3,
                "is-multiple": true,
                "is-editable": true,
                "is-deletable": true,
                "show-icons": true,
                "show-qr-code": true,
                "contact-qr-title": _unref(potential)?.title,
                "show-add-button": true,
                "contact-data": _unref(potential)?.contact,
                onContactUpdated: handleContactUpdated,
                onContactDeleted: _cache[8] || (_cache[8] = ($event: any) => (handleContactDeleted($event))),
                onContactAdded: _cache[9] || (_cache[9] = ($event: any) => (handleContactAdded($event)))
              }, null, 8, ["contact-qr-title", "contact-data"])
            ]),
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              (_unref(potential)?.comments.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(CommentListDisplayer, {
                      comments: _unref(potential)?.comments
                    }, null, 8, ["comments"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
            ]),
            _createVNode(CommentField, {
              class: "!mt-[4.8rem] w-3/4 pb-24",
              onCommentSubmitted: _cache[10] || (_cache[10] = ($event: any) => (addCommentToPotential($event))),
              text: _unref(potential)?.comments,
              placeholder: "Yorumunuzu buraya yazın veya iptal etmek için 'esc' tuşuna basın."
            }, null, 8, ["text"])
          ]),
          (!_unref(isLoadingPotential))
            ? (_openBlock(), _createElementBlock("aside", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (moveToTracked())),
                    class: "ac-primary-button w-full text-2xl mb-4"
                  }, " İzlenenlere Taşı "),
                  _createElementVNode("button", {
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (addReminder())),
                    class: "ac-secondary-button w-full text-2xl mb-4"
                  }, " Hatırlatma Ekle "),
                  _createElementVNode("button", {
                    class: "ac-secondary-button w-full text-2xl mb-4",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (sendIntroMail()))
                  }, " Tanıtım Belgesi Gönder "),
                  (_unref(potential)?.status === 'ACTIVE')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (updateSinglePotentialField('status', 'INACTIVE'))),
                        class: "ac-secondary-button w-full text-2xl mb-4"
                      }, " Deaktif Hale Getir "))
                    : _createCommentVNode("", true),
                  (_unref(potential)?.status === 'INACTIVE')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (updateSinglePotentialField('status', 'ACTIVE'))),
                        class: "ac-secondary-button w-full text-2xl mb-4"
                      }, " Aktif Hale Getir "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createVNode(StarPicker, {
                      "picked-quantity": _unref(potential)?.potentialRating!,
                      "max-quantity": 5,
                      "onUpdate:pickedQuantity": _cache[16] || (_cache[16] = ($event: any) => (updateSinglePotentialField('potentialRating', $event)))
                    }, null, 8, ["picked-quantity"])
                  ]),
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(potential)?.type === "company" ? "Şirket" : "Kişi"), 1)
                  ]),
                  (_unref(potential)?.referredBy)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(potential)?.referredBy.userName), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(potential)?.thirdPartyRefferrer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(potential).thirdPartyRefferrer), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("img", {
                      src: _unref(potential)?.addedBy.profileImage,
                      referrerpolicy: "no-referrer",
                      alt: "Profile Image",
                      class: "rounded-image-mini rounded-full"
                    }, null, 8, _hoisted_35),
                    _createElementVNode("p", _hoisted_36, _toDisplayString(_unref(potential)?.addedBy.userName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("p", _hoisted_39, _toDisplayString(_unref(formatDate)(_unref(potential)?.createdAt.toDate())), 1)
                  ]),
                  _hoisted_40,
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("img", {
                        src: _unref(potential)?.updatedAt.user.profileImage,
                        referrerpolicy: "no-referrer",
                        alt: "Profile Image",
                        class: "rounded-image-mini rounded-full"
                      }, null, 8, _hoisted_44),
                      _createElementVNode("p", _hoisted_45, _toDisplayString(_unref(potential)?.updatedAt.user.userName), 1),
                      _hoisted_46,
                      _createElementVNode("p", _hoisted_47, _toDisplayString(_unref(formatDate)(_unref(potential)?.updatedAt.date.toDate())), 1)
                    ])
                  ])
                ]),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                  _createVNode(_Transition, {
                    appear: "",
                    type: "animation",
                    "enter-active-class": "animate__animated animate__fadeIn animate__fast",
                    "leave-active-class": "animate__animated animate__fadeOut animate__faster"
                  }, {
                    default: _withCtx(() => [
                      (isAddingReminder.value)
                        ? (_openBlock(), _createBlock(AcMediumModal, {
                            key: 0,
                            onModalClosed: _cache[19] || (_cache[19] = ($event: any) => {isAddingReminder.value = false; _unref(modalClosed)()}),
                            class: "lg:!top-44 overflow-y-scroll",
                            title: "Hatırlatma Ekle",
                            width: "50vw",
                            height: "fit-content"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(AddReminderForm, {
                                onReminderAdded: _cache[17] || (_cache[17] = ($event: any) => (handleReminderAdded($event))),
                                onCancelled: _cache[18] || (_cache[18] = ($event: any) => {isAddingReminder.value = false; _unref(modalClosed)();})
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})